document.addEventListener('DOMContentLoaded', function() {
  const initCarousels = function() {
    const carousels$ = document.querySelectorAll('.collections-carousel');

    carousels$.forEach(function(carousel$) {
      if (carousel$.dataset.initialized === 'true') return;

      const viewport$ = carousel$.querySelector('.carousel-viewport');
      const prevButton$ = carousel$.querySelector('.carousel-arrow-prev');
      const nextButton$ = carousel$.querySelector('.carousel-arrow-next');

      if (!viewport$ || typeof EmblaCarousel === 'undefined') return;

      carousel$.dataset.initialized = 'true';

      const slides$ = carousel$.querySelectorAll('.carousel-slide');
      const gap = parseInt(getComputedStyle(carousel$).getPropertyValue('--carousel-gap')) || 5;

      const getSlidesPerView = function() {
        return window.innerWidth >= 750 ? 4 : 2.5;
      };

      const calculateSlideWidth = function() {
        const slidesPerView = getSlidesPerView();
        const totalGap = gap * (slidesPerView - 1);
        return (viewport$.offsetWidth - totalGap) / slidesPerView;
      };

      const setSlideWidths = function() {
        const slideWidth = calculateSlideWidth();
        slides$.forEach(function(slide$) {
          slide$.style.flex = '0 0 ' + slideWidth + 'px';
          slide$.style.minWidth = slideWidth + 'px';
          slide$.style.marginRight = gap + 'px';
        });
      };

      const getEmblaOptions = function() {
        const isMobile = window.innerWidth < 750;
        const wrapper$ = carousel$.querySelector('.carousel-wrapper');
        const isStatic = (isMobile && wrapper$ && wrapper$.classList.contains('mobile-static')) ||
                         (!isMobile && wrapper$ && wrapper$.classList.contains('desktop-static'));

        return {
          loop: !isStatic,
          align: 'start',
          slidesToScroll: 1,
          containScroll: false,
          watchDrag: !isStatic,
          active: !isStatic
        };
      };

      setSlideWidths();

      let embla = EmblaCarousel(viewport$, getEmblaOptions());

      const handleResize = function() {
        setSlideWidths();
        if (embla) {
          embla.reInit(getEmblaOptions());
        }
      };

      const handlePrevClick = function() {
        embla.scrollPrev();
      };

      const handleNextClick = function() {
        embla.scrollNext();
      };

      if (prevButton$) {
        prevButton$.addEventListener('click', handlePrevClick);
      }

      if (nextButton$) {
        nextButton$.addEventListener('click', handleNextClick);
      }

      window.addEventListener('resize', handleResize);
    });
  };

  if (typeof EmblaCarousel !== 'undefined') {
    initCarousels();
  } else {
    const checkEmbla = setInterval(function() {
      if (typeof EmblaCarousel !== 'undefined') {
        clearInterval(checkEmbla);
        initCarousels();
      }
    }, 50);
  }
});
